<template>
  <div>
    <div class="banner" id="banner">
      <div class="banner-container">
        <img
          style="width: 100%; height: 100%"
          :src="$t('picture.travelBanner')"
          alt=""
        />
      </div>
    </div>

    <div class="banner_box_media">
      <div class="platform_img_right">
        <img
          style="width: 100%; height: 100%"
          src="../../public/static/img/travel/right.png"
          alt=""
        />
      </div>
      <div class="platform_img_left">
        <img
          style="width: 100%; height: 100%"
          src="../../public/static/img/travel/left.png"
          alt=""
        />
      </div>
      <div class="banner_center_media">
        <div class="media_title" style="margin-bottom: 0">
          {{ $t("travel.platform") }}
        </div>
        <div class="platform">
          <img
            class="platform_img"
            src="../../public/static/img/travel/chu.png"
            alt=""
          />
        </div>

        <div class="media_title mb0">
          {{ $t("travel.APP") }}
          <div class="co63">
            {{ $t("travel.APP_") }}
          </div>
        </div>

        <div class="platform mb100">
          <img
            class="platform_img"
            src="../../public/static/img/travel/tian.png"
            alt=""
          />
        </div>

        <div class="media_title">{{ $t("travel.engine") }}</div>
        <div
          style="margin: auto"
          :style="{
            width: $t('travel.engine_width'),
            height: $t('travel.engine_height'),
          }"
        >
          <img
            style="width: 100%; height: 100%"
            :src="$t('picture.travel')"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="banner_box_media" style="background-color: #f7f7f7">
      <div class="banner_center_media">
        <div class="media_title mb40">
          {{ $t("travel.joint") }}
          <div class="fz26">
            {{ $t("travel.joint_") }}
          </div>
        </div>

        <div class="lian_widthHeight">
          <img
            style="width: 100%; height: 100%"
            src="../../public/static/img/travel/lian.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media pd0">
        <div class="media_title marginBottom0">
          {{ $t("travel.recruit") }}
        </div>
      </div>
    </div>

    <div class="banner_container_coop" @click="$router.push('recruit')">
      <img
        style="width: 100%; height: 100%"
        :src="$t('picture.partner')"
        alt=""
      />
    </div>

    <div class="banner_box_media">
      <div class="banner_center_media">
        <div class="media_title goCaseWidthHeight">
          <div class="goCase" @click="$router.push('channel')">
            {{ $t("travel.channelCase") }}<i class="el-icon-arrow-right"></i>
          </div>
          <div class="goCase" @click="$router.push('offline')">
            {{ $t("travel.offline") }}<i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped lang="less">
.clear {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.banner .banner-container {
  padding-top: 86px;
  min-height: 638px;
  // background-image: url("http://travelmall.portus.cn/2023/04/ca4c8f12dcf448dcb701cc495dfdd61f.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
}
.banner_container_coop {
  // padding-top: 86px;
  min-height: 638px;
  // background-image: url("http://travelmall.portus.cn/2023/04/c8ca78a7c63045b8bd36e8c545236b6a.png");
  background-repeat: no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
}
</style>